module.exports = __webpack_public_path__ + "img/35.5d9d6d25.jpg";